(() => {
	const sel = {
		group: ".js-collection-group",
	};

	const MAX_CONCURRENT = 3;
	const queue = [];
	let active = 0;

	function enqueue(task) {
		queue.push(task);
		runNext();
	}

	function runNext() {
		if (active >= MAX_CONCURRENT) return;
		const next = queue.shift();
		if (!next) return;
		active++;
		next().finally(() => {
			active--;
			runNext();
		});
	}

	async function fetchFragment(url) {
		const res = await fetch(url, { credentials: "same-origin" });
		if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
		return res.text();
	}

	function initGroup(el) {
		if (el.__shopAllInit) return;
		el.__shopAllInit = true;

		const handle = el.getAttribute("data-collection-handle");
		const productCount = parseInt(
			el.getAttribute("data-product-count") || "0",
			10
		);
		const initialPage = parseInt(
			el.getAttribute("data-initial-page") || "1",
			10
		);

		// Skip loading if collection has no products
		if (productCount === 0) {
			return;
		}

		const state = {
			page: initialPage,
			loading: false,
			done: false,
		};

		const loadPage = page =>
			enqueue(async () => {
				if (state.loading || state.done) return;

				state.loading = true;
				el.setAttribute("data-loading", "true");
				const url = `/collections/${encodeURIComponent(
					handle
				)}?view=shop-all-grid&page=${page}`;

				try {
					const html = await fetchFragment(url);
					const tmp = document.createElement("div");
					tmp.innerHTML = html;

					const fragment = tmp.querySelector(".shop-all-fragment");
					const grid = tmp.querySelector("[data-grid]");

					if (fragment) {
						const error = fragment.getAttribute("data-error");

						if (error) {
							// Show error message to user
							const errorDiv = document.createElement("div");
							errorDiv.className = "shop-all__error";
							errorDiv.innerHTML = `<p>Unable to load products for ${handle}. The collection may not exist.</p>`;
							el.appendChild(errorDiv);
						} else if (grid) {
							// Remove placeholder
							const ph = el.querySelector(".shop-all__placeholder");
							if (ph) ph.remove();

							// Create or get target grid
							const targetGrid =
								el.querySelector("[data-grid]") ||
								(() => {
									const g = document.createElement("div");
									g.setAttribute("data-grid", "");
									g.className =
										"container has-column-padding-bottom featured-collection c-container layout--grid";
									el.appendChild(g);
									return g;
								})();

							// Append products
							targetGrid.insertAdjacentHTML("beforeend", grid.innerHTML);
						}
					}

					// Mark as done after first load
					state.done = true;
				} catch (e) {
					console.error("Shop All load error", e);
				} finally {
					state.loading = false;
					el.setAttribute("data-loading", "false");
				}
			});

		// Lazy load first page on intersection
		const io = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						loadPage(state.page);
						io.disconnect();
					}
				});
			},
			{ rootMargin: "200px 0px" }
		);
		io.observe(el);
	}

	function init() {
		const groups = document.querySelectorAll(sel.group);
		if (!groups.length) return;
		groups.forEach(initGroup);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
